import AuthLayout from "../components/layout/AuthLayout";
import Signin from "../pages/auth/Signin";
import Signup from "../pages/auth/SignUp";
import MagicLink from "../pages/auth/MagicLink";

const authRouter = [
  {
    path: "/auth",
    element: <AuthLayout />,
    children: [
      {
        path: "signup",
        element: <Signup />,
      },
      {
        path: "signin",
        element: <Signin />,
      },
      {
        path: "magic-login",
        element: <MagicLink />,
      },
    ],
  },
];

export default authRouter;
